/**
 * S12 · Let's get started (#start) — THE FEED homepage, design.md Part III.
 * FINAL-SPEC §4 S12. The burst, the squeeze, the push-card drop + haptic shake
 * and the live hearts are all CSS (the shared IO adds `.in` / `.live`). This
 * only runs the REC button's timecode: a mono `00:00:SS` that ticks while the
 * proposal button is hovered or focused (decorative, aria-hidden), like a
 * camera that started recording. Nothing ticks under reduced motion.
 */
import { reduced } from "./runtime";

const pad = (n: number): string => String(n).padStart(2, "0");

export function init(): void {
  const rec = document.querySelector<HTMLElement>("#start .start__rec");
  const tc = rec?.querySelector<HTMLElement>(".start__tc");
  if (!rec || !tc) return;
  let timer = 0;
  let secs = 0;
  const stop = (): void => {
    window.clearInterval(timer);
    timer = 0;
    secs = 0;
    tc.textContent = "00:00:00";
  };
  const start = (): void => {
    if (timer || reduced()) return;
    timer = window.setInterval(() => {
      secs += 1;
      const m = Math.floor(secs / 60) % 60;
      tc.textContent = `00:${pad(m)}:${pad(secs % 60)}`;
    }, 1000);
  };
  rec.addEventListener("pointerenter", start);
  rec.addEventListener("pointerleave", () => {
    if (document.activeElement !== rec) stop();
  });
  rec.addEventListener("focus", () => {
    if (rec.matches(":focus-visible")) start();
  });
  rec.addEventListener("blur", stop);
}
